// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TAcceptRealEstateRequest,
  TAcceptRealEstateModel,
  IMappers,
  TAcceptRealEstateResponse,
  TAcceptRealEstateResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createAcceptRealEstateModel(parameters: TAcceptRealEstateRequest): TAcceptRealEstateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-dobro',
    pathApi: '/v1/accept-real-estate/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAcceptRealEstateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAcceptRealEstateRequest;
}

export async function fetchAcceptRealEstate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAcceptRealEstateOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAcceptRealEstateResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAcceptRealEstateModel(parameters),
    config,
  )) as FetchResponse<TAcceptRealEstateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TAcceptRealEstateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAcceptRealEstateResponse>;
}
